import React from 'react';
import classNames from 'classnames';

import { Text, textVariantsEnum, fontWeightEnum } from '@components/Text';

import styles from './StatHighlightCard.module.scss';

export const statHighlightTones = {
  success: 'success',
  info: 'info',
  warning: 'warning',
};

export const StatHighlightCard = ({
  value,
  label,
  sublabel,
  tone = statHighlightTones.success,
  className,
}) => (
  <div
    className={classNames(
      styles.card,
      { [styles[`card_tone_${tone}`]]: tone },
      className
    )}
  >
    <Text
      variant={textVariantsEnum.Display_sm}
      fontWeight={fontWeightEnum.Bold}
      className={styles.value}
    >
      {value}
    </Text>
    {label && (
      <Text
        variant={textVariantsEnum.Text_sm}
        fontWeight={fontWeightEnum.Semibold}
        color="gray-900"
      >
        {label}
      </Text>
    )}
    {sublabel && (
      <Text
        variant={textVariantsEnum.Text_xs}
        fontWeight={fontWeightEnum.Normal}
        color="gray-600"
      >
        {sublabel}
      </Text>
    )}
  </div>
);

StatHighlightCard.displayName = 'StatHighlightCard';
